export enum ProjectReportScanStatus {
  Unknown = 0,
  Failed,
  Scanning,
  Complete,
  Canceled,
  Queued,
  GettingFiles,
  ReportGeneration
}
